export const splitRelativeDateString = (
  relativeDateStr: string,
): [dateParameter: string, relativeDateEquation: string] => {
  const [dateParameterStr = 'now', relativeDateEquationStr = ''] = relativeDateStr
    .split(/^([^+-].*?)?([+-].*)?$/g)
    .slice(1);
  return [dateParameterStr, relativeDateEquationStr];
};
